

<app-header-helena bannerImage="horizon-sprayer.png"></app-header-helena>
<h1>{{title}}</h1>



<h1 >Liquid fertiliser application</h1>
<p >To achieve the best results when using fertilisers, the nutrients have to be spread accurately and evenly and at the right rate across the whole spreader width. 
    A high quality fertiliser is important, but so is how you spread it!</p>


<h2 >Liquid fertiliser application</h2>

<p>Liquid fertiliser can be applied through an existing farm sprayer and can give an immediate improvement to the nutritional conditions of the crops.</p>

<ul>
    <li >Application accuracy: Across the full boom width however wide, over the entire field with the correct amount applied per hectare, at the end of bouts by reducing overlaps and especially at the field margins right up to the crop’s edge - and no further.</li>
    <li >Benefits include: More even crops, reduced overlapping on headlands, less fertiliser wastage, less risk of lodging and diseases, easier combining, more consistent grain samples and higher yields</li>
</ul>

<p >Find further information on Yara liquid fertilisers</p>

<h2 >Ele-Max fertiliser application</h2>

<p >Ele-Max foliar spray products are widely tankmixable with other agrochemical 
    inputs to make treatment easier and more convenient. 
    At <a href="/helena">www.tankmix.com</a> and in the Yara TankmixIT App you will find the results of more than 30.000 tank mix tests. The service is updated daily and is searchable by product or by active ingredient.</p>

<!-- <div markdown [src]="sourcePath">
  
</div> -->
